<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5141_45327)">
<rect x="6.30908" y="16.3828" width="15.0848" height="3.99299" rx="1.9965" transform="rotate(-45 6.30908 16.3828)" stroke="currentColor" stroke-width="2"/>
<rect x="0.831055" y="16.6016" width="23.2462" height="11.4317" rx="5.71586" transform="rotate(-45 0.831055 16.6016)" stroke="currentColor" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_5141_45327">
<rect width="24" height="24" fill="white" transform="translate(0.666992)"/>
</clipPath>
</defs>
</svg>
